// Run this BEFORE the theme initializes AjaxProduct
//const form = document.querySelector('.product-single__form');
const atcProductOffer = document.querySelector('.add-product-offer');
const cartDrawerButton = document.querySelector('.js-drawer-open-cart');
const purchaseTypes = document.querySelectorAll('input[name="purchaseType"]');
const mainAtc = document.querySelector('.product-single__form button[data-add-to-cart]');
const offerRadio = document.querySelector('#purchaseProductOffer');
const sellingPlanSelect = document.querySelector('.selling-plan-selector');
const hiddenSellingPlanInput = document.querySelector('input[name="selling_plan"]');
const priceWrapper = document.querySelector('.purchase-option__price');
const comparePriceEl = document.querySelector('.purchase-option__compare');
const currentPriceEl = document.querySelector('.purchase-option__current');
const purchaseOptionContent = document.querySelector('.purchase-option__content');
const purchaseOptionsLbls = document.querySelectorAll('.purchase-option');
const launchBadge = document.querySelector('.bundle-product-offer .launch-badge');

function isB2bCustomer() {
    return (
        document.documentElement.classList.contains('b2b-customer') ||
        window.ANANDA_B2B_CUSTOMER === true
    );
}

function updateSummerMocktailVariantUrl(variantId) {
    if (!variantId || !window.history || typeof window.history.replaceState !== 'function') {
        return;
    }

    var id = parseInt(variantId, 10);
    if (!id || isNaN(id)) {
        return;
    }

    var searchParams = new URLSearchParams(window.location.search);
    searchParams.set('variant', String(id));
    var queryString = searchParams.toString();
    var newUrl = window.location.pathname + (queryString ? '?' + queryString : '');

    if (window.location.pathname + window.location.search !== newUrl) {
        window.history.replaceState({ path: newUrl }, '', newUrl);
    }
}

function getSummerMocktailVariantIdFromPicker() {
    var productSection = document.querySelector('[data-section-type="product"]');
    if (!productSection) {
        return null;
    }

    var checked = productSection.querySelector('[data-variant-input]:checked');
    if (checked) {
        var directId = checked.getAttribute('variant-id') || checked.dataset.variantId;
        if (directId) {
            return parseInt(directId, 10);
        }
    }

    var masterSelect = productSection.querySelector('select[data-product-select], select[name="id"]');
    if (masterSelect && masterSelect.value) {
        return parseInt(masterSelect.value, 10);
    }

    return null;
}

function initSummerMocktailVariantUrlSync() {
    function syncUrlFromVariant(variant) {
        if (variant && variant.id) {
            updateSummerMocktailVariantUrl(variant.id);
            return;
        }

        var resolvedId = getSummerMocktailVariantIdFromPicker();
        if (resolvedId) {
            updateSummerMocktailVariantUrl(resolvedId);
        }
    }

    document.addEventListener('variant:change', function(evt) {
        syncUrlFromVariant(evt.detail && evt.detail.variant);
    });

    document.addEventListener('variantChange', function(evt) {
        if (!evt.target || !evt.target.closest('[data-section-type="product"]')) {
            return;
        }
        syncUrlFromVariant(evt.detail && evt.detail.variant);
    });

    document.addEventListener('change', function(evt) {
        if (!evt.target.matches('[data-variant-input]')) {
            return;
        }

        window.requestAnimationFrame(function() {
            var variantId = evt.target.getAttribute('variant-id') || evt.target.dataset.variantId;
            if (variantId) {
                updateSummerMocktailVariantUrl(variantId);
                return;
            }

            var masterSelect = document.querySelector('[data-section-type="product"] select[data-product-select], select[name="id"]');
            if (masterSelect && masterSelect.value) {
                updateSummerMocktailVariantUrl(masterSelect.value);
            }
        });
    });

    document.addEventListener('click', function(evt) {
        if (!evt.target.closest('.product-variant_picker label')) {
            return;
        }

        window.requestAnimationFrame(function() {
            window.requestAnimationFrame(function() {
                syncUrlFromVariant(null);
            });
        });
    });
}

function snapB2bQty(val) {
    var min = 4;
    var step = 4;
    var n = parseInt(val, 10);
    if (isNaN(n)) return min;
    if (n < min) return min;
    return min + Math.round((n - min) / step) * step;
}

function getSummerMocktailQuantity(trigger) {
    const productSection = document.querySelector('[data-section-type="product"]') || document;
    const productForm = trigger
        ? trigger.closest('.product-single__form')
        : document.querySelector('.product-single__form');
    const quantityWithAtc = productForm ? productForm.closest('.quantity-with-atc') : null;
    const formQuantity = productForm ? productForm.querySelector('input[name="quantity"]') : null;
    let formDataQuantity = null;

    if (productForm) {
        try {
            formDataQuantity = new FormData(productForm).get('quantity');
        } catch (error) {
            formDataQuantity = null;
        }
    }

    const localQuantity = quantityWithAtc
        ? quantityWithAtc.querySelector('.product__quantity input[name="quantity"]')
        : null;
    const linkedQuantity = productForm && productForm.id
        ? productSection.querySelector(`input[name="quantity"][form="${productForm.id}"]`)
        : null;
    const quantityInput = formQuantity || localQuantity || linkedQuantity || productSection.querySelector('.product__quantity input[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    if (quantity && quantity > 0) {
        return isB2bCustomer() ? snapB2bQty(quantity) : quantity;
    }

    const parsedFormDataQuantity = parseInt(formDataQuantity, 10);
    if (parsedFormDataQuantity && parsedFormDataQuantity > 0) {
        return isB2bCustomer() ? snapB2bQty(parsedFormDataQuantity) : parsedFormDataQuantity;
    }

    return isB2bCustomer() ? 4 : 1;
}

document.addEventListener('DOMContentLoaded', function() {
    initSummerDescriptionToggle();
    initSummerMocktailVariantUrlSync();

    if (isB2bCustomer()) {
        var onetimeRadio = document.querySelector('input[name="purchaseType"][value="onetime"]');
        if (onetimeRadio) {
            onetimeRadio.checked = true;
            onetimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (mainAtc) mainAtc.style.display = 'inline-block';
        if (atcProductOffer) atcProductOffer.style.display = 'none';
        if (launchBadge) launchBadge.classList.remove('selected');
        if (hiddenSellingPlanInput) hiddenSellingPlanInput.value = '';
    } else if (offerRadio) {
        offerRadio.click();
    }

    purchaseTypes.forEach(el => {
        el.addEventListener('change', function() {
            if (isB2bCustomer() && el.value !== 'onetime') {
                var onetimeRadio = document.querySelector('input[name="purchaseType"][value="onetime"]');
                if (onetimeRadio) {
                    onetimeRadio.checked = true;
                    onetimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
                }
                return;
            }

            purchaseOptionsLbls.forEach(el => {
                el.classList.remove('opt-selected');
            });
            const purchaseOptionLbl = el.closest('.purchase-option');
            purchaseOptionLbl.classList.add('opt-selected');
            
            if(el.value === 'purchaseProductOffer') {
                mainAtc.style.display = 'none';
                atcProductOffer.style.display = 'inline-block';
                launchBadge.classList.add('selected');
            }
            else {
                mainAtc.style.display = 'inline-block';
                atcProductOffer.style.display = 'none';
                launchBadge.classList.remove('selected');
            }
            updateSellingPlan();

            const selectedPurchaseType = document.querySelector('input[name="purchaseType"]:checked');
            if(selectedPurchaseType.value === 'subscription') {
                purchaseOptionContent.style.display = 'block';
            }
            else {
                purchaseOptionContent.style.display = 'none';
            }
        });
    })

    if (atcProductOffer) {
    atcProductOffer.addEventListener('click', async (e) => {
        e.preventDefault();

        if (isB2bCustomer()) {
            var productForm = document.querySelector('.product-single__form');
            if (productForm && typeof productForm.requestSubmit === 'function') {
                productForm.requestSubmit();
            }
            return;
        }

        if (offerRadio?.checked) {
            const variantId = offerRadio.dataset.variantId;

            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                    items: [
                        {
                        id: variantId,
                        quantity: getSummerMocktailQuantity(e.currentTarget)
                        }
                    ]
                    })
                });

                const data = await response.json();

                console.log('Added:', data);
                const localCartDrawer = new theme.CartDrawer();
                if (cartDrawerButton) {
                    cartDrawerButton.click();
                }

                // optional cart refresh / drawer open
                document.dispatchEvent(
                    new CustomEvent('cart:refresh')
                );

            } catch (error) {
                console.error('Add to cart failed:', error);
            }
        }
    });
    }

    
    // Initial load
    updateSellingPlan();

    // Change subscription frequency
    if (sellingPlanSelect) {
        sellingPlanSelect.addEventListener('change', updateSellingPlan);
    }

    Fancybox.bind("[data-fancybox]", {});
});

function initSummerDescriptionToggle() {
    const descriptionBlock = document.querySelector('[data-summer-description-toggle]');
    if (!descriptionBlock) return;

    const description = descriptionBlock.querySelector('.rte');
    if (!description) return;

    const originalHtml = description.innerHTML;
    const fullText = description.textContent.replace(/\s+/g, ' ').trim();
    const mobileQuery = window.matchMedia('(max-width: 768px)');
    const collapsedLength = 76;

    if (fullText.length <= collapsedLength) return;

    function renderCollapsed() {
        const trimmedText = fullText.slice(0, collapsedLength).replace(/\s+\S*$/, '');

        description.innerHTML = '';
        description.append(document.createTextNode(`${trimmedText}... `));
        description.append(createToggleButton('Read more', false));
        descriptionBlock.classList.add('summer-description-toggle', 'is-collapsed');
        descriptionBlock.classList.remove('is-expanded');
    }

    function renderExpanded() {
        description.innerHTML = originalHtml;
        description.append(createToggleButton('Read less', true));
        descriptionBlock.classList.add('summer-description-toggle', 'is-expanded');
        descriptionBlock.classList.remove('is-collapsed');
    }

    function createToggleButton(label, isExpanded) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'summer-description-toggle__button';
        button.textContent = label;
        button.setAttribute('aria-expanded', String(isExpanded));
        button.addEventListener('click', isExpanded ? renderCollapsed : renderExpanded);
        return button;
    }

    function syncDescription() {
        if (mobileQuery.matches) {
            renderCollapsed();
        } else {
            description.innerHTML = originalHtml;
            descriptionBlock.classList.remove('summer-description-toggle', 'is-collapsed', 'is-expanded');
        }
    }

    syncDescription();

    if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', syncDescription);
    } else {
        mobileQuery.addListener(syncDescription);
    }
}


function updateSellingPlan() {
    console.log(`updateSellingPlan: ${sellingPlanSelect.value}`);
    const selectedPurchaseType = document.querySelector('input[name="purchaseType"]:checked');
    const isSubscription = selectedPurchaseType && selectedPurchaseType.value === 'subscription';

    if (!hiddenSellingPlanInput) return;

    // Subscription selected
    if (isSubscription && sellingPlanSelect) {
        hiddenSellingPlanInput.value = sellingPlanSelect.value;
    } 
    else {
        // One-time purchase
        hiddenSellingPlanInput.value = '';
    }

    // Price display
    if (sellingPlanSelect) {
        const selectedOption = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];

        const price = selectedOption.dataset.price;
        const comparePrice = selectedOption.dataset.comparePrice;

        currentPriceEl.textContent = price;

        if (comparePriceEl && comparePrice) {
            comparePriceEl.textContent = comparePrice;
        }
    } 
    else {
        const defaultPrice = priceWrapper.dataset.productPrice;
        const defaultComparePrice = priceWrapper.dataset.productComparePrice;

        currentPriceEl.textContent = Shopify.formatMoney(defaultPrice);

        if (comparePriceEl && defaultComparePrice) {
            comparePriceEl.textContent = Shopify.formatMoney(defaultComparePrice);
        }
    }
}
